module.exports = __webpack_public_path__ + "static/media/Reddit.86411f17.svg";